module.exports = __webpack_public_path__ + "static/logo-359f14e4abe90baac4ecdc00e324c7df.png";